module.exports = __webpack_public_path__ + "img/logo(2)-160x54.ffb40ce4.png";